var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIadd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.24037 1.74037C1.76632 2.21442 1.5 2.85737 1.5 3.52778V12.4722C1.5 13.1426 1.76632 13.7856 2.24037 14.2596C2.71442 14.7337 3.35737 15 4.02778 15H12.9722C13.6426 15 14.2856 14.7337 14.7596 14.2596C15.2337 13.7856 15.5 13.1426 15.5 12.4722V3.52778C15.5 2.85737 15.2337 2.21442 14.7596 1.74037C14.2856 1.26632 13.6426 1 12.9722 1H4.02778C3.35737 1 2.71442 1.26632 2.24037 1.74037ZM9.5 4C9.5 3.44772 9.05228 3 8.5 3C7.94772 3 7.5 3.44772 7.5 4V7H4.5C3.94772 7 3.5 7.44772 3.5 8C3.5 8.55228 3.94772 9 4.5 9H7.5V12C7.5 12.5523 7.94772 13 8.5 13C9.05228 13 9.5 12.5523 9.5 12V9H12.5C13.0523 9 13.5 8.55228 13.5 8C13.5 7.44772 13.0523 7 12.5 7H9.5V4Z",
    fill: "#828EE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIadd);
export default __webpack_public_path__ + "static/media/iadd.67b0fe4dcc8f6e31dcdda26e942ea1db.svg";
export { ForwardRef as ReactComponent };